import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EducationalQualificationDto  {
    _originalTypeClassName = "zERP.BO.EducationalQualificationDto";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EducationalQualificationDto.translate = translateService;
}
this.TitleName = null;
this.Duration = null;
this.GraduationDate = null;
this.acknowledged = false;
this.Code_ = null;
this.DocumentType = null;
this.DocumentDescription = null;
this.DocumentPath = null;
this.AcquisitionYear = null;
this.Diploma = null;
this.Id = null;
this.InstotutionId = null;
this.InstitutionName = null;
this.Level = null;
this.EducationalDirection = null;
this.StudiesField = null;
this.GraduationYear = null;
this.EducationalQualificationDtoKey = null;
this._key = this.EducationalQualificationDtoKey = 0; 
}

static translate: TranslateService;
_key: any;
TitleName:any;
Duration:any;
GraduationDate:any;
acknowledged:any;
Code_:any;
DocumentType:any;
DocumentDescription:any;
DocumentPath:any;
AcquisitionYear:any;
Diploma:any;
Id:any;
InstotutionId:any;
InstitutionName:any;
Level:any;
EducationalDirection:any;
StudiesField:any;
GraduationYear:any;
Institution:any;
EducationalDirectionEQ:any;
StudiesLevel:any;
private _EducationalQualificationDtoKey:any;
get EducationalQualificationDtoKey(): any {
    return this._EducationalQualificationDtoKey;
  }
set EducationalQualificationDtoKey(value: any) {
    this._EducationalQualificationDtoKey = value;
    this._key = value;
  }
static setInstitution = ($this, value) => {
var oldValue = $this.Institution;
$this.Institution = value;
if (value != null) {
}
}
static setEducationalDirectionEQ = ($this, value) => {
var oldValue = $this.EducationalDirectionEQ;
$this.EducationalDirectionEQ = value;
if (value != null) {
}
}
static setStudiesLevel = ($this, value) => {
var oldValue = $this.StudiesLevel;
$this.StudiesLevel = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EducationalQualificationDtoKey == null || $this.EducationalQualificationDtoKey == 0;
            }


}